import { globalVariable } from '@/utils/exportVariable'
import { getCouponList } from '@/api/fission'

function getFissionDatas() {
  const { fissionInfos = {} } = globalVariable.store.state
  return fissionInfos
}

function hasType(datas, type) {
  return datas.some((item) => item.awardType * 1 === type * 1)
}
function getTypeOfDatas(datas, type) {
  return datas.filter((item) => item.awardType * 1 === type * 1)
}

function getArrSum(data = [], paymentedMaxAwards) {
  let sum = 0
  data.forEach((item) => {
    if (item.conditionType * 1 === 4) {
      sum += item.awardCount * paymentedMaxAwards.conditionCount
    } else {
      sum += item.awardCount
    }
  })
  return sum
}
// 获取活动配置中最大的的奖励信息
// 活动同时配置了优惠券、商品、K币，展示优先级：商品 > kgold > 优惠券
export async function getMaxAwardInfos() {
  const datas = getFissionDatas()
  const { extraInfo = {} } = datas || {}
  const { splitActivityConditionList } = extraInfo

  const hasCoupon = hasType(splitActivityConditionList, 3)
  const hasSku = hasType(splitActivityConditionList, 4)
  const hasKgold = hasType(splitActivityConditionList, 5)

  const couponConditionDatas = getTypeOfDatas(splitActivityConditionList, 3)
  const skuConditionDatas = getTypeOfDatas(splitActivityConditionList, 4)
  const kgoldConditionDatas = getTypeOfDatas(splitActivityConditionList, 5)

  // 付费封顶
  const paymentedMaxAwards =
    (splitActivityConditionList.filter(
      (item) => item.conditionType * 1 === 5
    ) || [])[0] || {}

  // 商品：数字 + 商品icon； 如果配置了多个商品奖励，则展示商品奖励总数
  // 【奖励方式-登陆-钻石或UC数量】+【奖励方式-首次分享-钻石或UC数量】+SUM【奖励方式-新用户注册奖励-钻石或UC数量】+【奖励方式-新用户付费奖励-钻石或UC数量】*【奖励方式-新用户付费峰顶奖励-峰顶人数】+SUM【奖励方式-新用户付费峰顶奖励-钻石或UC数量】
  if (hasSku) {
    return {
      awardCount: getArrSum(skuConditionDatas, paymentedMaxAwards),
      awardType: 4,
    }
  }
  // kgold：货币符号  数字（最多放几位） + kgold icon
  if (hasKgold) {
    return {
      awardCount: getArrSum(kgoldConditionDatas, paymentedMaxAwards),
      awardType: 5,
    }
  }
  // 券：数字%OFF/货币符号 数字 OFF + 券icon；如果配置了多张优惠券，则优惠券奖品取所有配置的优惠券中最高的那张（优先满减券，其次折扣券）
  if (hasCoupon) {
    const couponIds = couponConditionDatas
      .map((item) => item.couponId)
      .join(',')
    const { region } = globalVariable.store.state
    const couponsDatas = await getCouponList({
      country: region,
      couponIdString: couponIds,
    })
    // <!-- couponType: 1 立减券 2折扣券 -->
    const reduction_coupon = couponsDatas.filter(
      (item) => item.couponType * 1 === 1
    )
    const discount_coupon = couponsDatas.filter(
      (item) => item.couponType * 1 === 2
    )
    // 有立减券
    const hasReductionCoupon = reduction_coupon.length > 0

    if (reduction_coupon.length === 0 && discount_coupon.length === 0) {
      return {}
    }

    if (hasReductionCoupon) {
      const sortCouponData =
        couponsDatas
          .filter((item) => item.couponType * 1 === 1)
          .sort((a, b) => b.couponPrice - a.couponPrice) || []
      return {
        awardType: 3,
        couponType: 1,
        awardCount: sortCouponData[0].couponPrice,
        currency: sortCouponData[0].currency,
      }
    } else {
      // 只有折扣券
      const sortDiscountData =
        discount_coupon.sort((a, b) => a.couponDiscount - b.couponDiscount) ||
        []

      return {
        awardType: 3,
        couponType: 2,
        awardCount: sortDiscountData[0].couponDiscount,
      }
    }
  }
}
